import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=dca21fa0&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dca21fa0')) {
      api.createRecord('dca21fa0', component.options)
    } else {
      api.reload('dca21fa0', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=dca21fa0&", function () {
      api.rerender('dca21fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gc08WG0ACP1A/JS/videoIframe.vue"
export default component.exports